(function () {
    'use strict';

    Directives.DownloadReportDirective = function DownloadReportDirective() {

        // @ngInject
        function DownloadReportDirectiveControllerFunc($element, DownloadReportService, $, $timeout, $scope, $injector, PopupMessageService) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'DownloadMonthlyReportDirectiveController';
            this.DownloadReportService = DownloadReportService;
            this.PopupMessageService = PopupMessageService;
            this.reportFunctions = {
                summaryReport: this.DownloadReportService.getSummaryReport.bind(this.DownloadReportService),
                leadsReport: this.DownloadReportService.getLeadsReport.bind(this.DownloadReportService),
                annualReport: this.DownloadReportService.getAnnualReport.bind(this.DownloadReportService),
                monthlyReport: this.DownloadReportService.getMonthlyReport.bind(this.DownloadReportService),
                archivedWorkspaces: this.DownloadReportService.getArchivedWorkspacesReport.bind(this.DownloadReportService),
                connectionsReport: this.DownloadReportService.getConnectionsReport.bind(this.DownloadReportService),
            };
            this.text = this.hbReportLink;
            this.inProgressText = this.hbReportLink || 'REPORTS.ANALYTICS._PREPARING_';
            this.downloadPending = false;

            $timeout(function timeoutElapsed() {

                $element.bind('click', function onClick() {

                    if (this.hbIsDisabled) {
                        return;
                    }

                    this.text = this.inProgressText;
                    this.downloadPending = true;

                    function handleLinkToDownloadIsPrepared(resp) {
                        if (!resp) {
                            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'REPORTS.ERRORS._GENERATE_REPORT_ERROR_');
                        }
                        else {
                            $element.parent().append($($.parseHTML('<a id="temp_link"></a>')));
                            var link = $element.parent().find("#temp_link");

                            // For yearly report, we run client pending worker that returns different format
                            var url = resp.data ? resp.data.url : resp;
                            link.attr("href", url);

                            // to avoid problems of $apply inside $apply
                            setTimeout(function () {
                                link[0].click();
                                link.remove();
                            }, 1);
                        }
                        this.text = this.hbReportLink;
                        this.downloadPending = false;
                    }

                    this.reportFunctions[this.hbReportName](this.hbReportArguments).then(
                        handleLinkToDownloadIsPrepared.bind(this),
                        function error(resp) {
                            this.text = this.hbReportLink;
                            this.downloadPending = false;
                        }.bind(this)
                    );
                }.bind(this));
            }.bind(this), 1);
        }

        var DownloadReportDirectiveController = Class(Controllers.BaseController, {
            constructor: DownloadReportDirectiveControllerFunc,
        });

        return {
            scope: {
                hbIsDisabled: '=',
                hbReportName: '@',
                hbReportLink: '@',
                hbReportArguments: '=',
                inProgressText: '=?',
                showIcon: '=?',
                showPendingIcon: '=?',
            },
            templateUrl: 'angular/app/modules/core/features/reports/analytics/download_report_template.html',
            controller: DownloadReportDirectiveController,
            controllerAs: 'downloadReportVm',
            bindToController: true
        };
    };
}());



